import { render, staticRenderFns } from "./CustomerOrderViewPage.vue?vue&type=template&id=94cc51c2&scoped=true"
import script from "./CustomerOrderViewPage.vue?vue&type=script&lang=js"
export * from "./CustomerOrderViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cc51c2",
  null
  
)

export default component.exports